import UsersIcon from "@heroicons/react/24/outline/QuestionMarkCircleIcon";
import {
  Avatar,
  Card,
  CardContent,
  Stack,
  SvgIcon,
  Typography,
  useTheme,
  Tooltip,
} from "@mui/material";
import { FormattedNumber } from "react-intl";

const CardPotentialGain = (props) => {
  const theme = useTheme();
  const { sx, earnings } = props;
  return (
    <Card sx={sx}>
      <CardContent>
        <Stack
          alignItems="flex-start"
          direction="row"
          justifyContent="space-between"
          spacing={3}
        >
          <Stack spacing={1}>
            <Typography color="text.secondary" variant="overline">
              guadagno potenziale
            </Typography>
            <Typography variant="h4" color={"#424242"}>
              <FormattedNumber value={earnings.theoreticalGain} />
              {" €"}
            </Typography>
          </Stack>
          <Tooltip title="Valore delle segnalazioni effettuate" placement="top-end">
            <SvgIcon>
              <UsersIcon style={{ color: theme.palette.primary.main }} />
            </SvgIcon>
          </Tooltip>
          {/* <Avatar
            sx={{
              backgroundColor: "childrenInProduction.main",
              height: 56,
              width: 56,
            }}
          >
            <SvgIcon>
              <UsersIcon />
            </SvgIcon>
          </Avatar> */}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CardPotentialGain;
